import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { ChatBox } from "../../components/ChatBox/ChatBox";
import { useSpreadSheet } from "../../context/spreadsheet-context";
import {
  listenerSingularCellSelection,
  listenerMultipleCellSelection,
  listenerEditedCellData,
  listenerLoadImport,
  // listenerCellStyle,
  listenerAddSheet,
  listenerOnChanged,
  listenerClients,
  emitRoomID,
  listenerClientArrOnDisconnect,
  listenAddMember
  // emitOnChanged
} from "../../socket";
import MouseContainer from "../mousecontainer";
import { useDocument } from "./documentInfoContex";
import { workwiseServices } from "../../Workw-Api/api";
import { formatFileSize } from "../../utils/helper";
import { message } from "antd";
import Loader from "../../components/SkeletonLoader/Loader";
import { removeOfflineData, saveToLocalStorage } from "../../x-data-spreadsheet/src/utils/helper";
import { loadServerData, updateAllSheets, updateSheet, templateService } from "../../utils/api";
import { updateOrAppendSheet } from "../../x-data-spreadsheet/src/utils/helper";

export const SpreadsheetContainer = ({
  contentLoading,
  setContentLoading,
}) => {
  // const konn = "http://192.168.18.81:8080";
  const konn = "https://grid.workw.com";
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();
  const { setCurrPos } = useSpreadSheet();
  const {
    setSheets,
    setDocumentInfo,
    setSavingData,
    sheets,
    setIsExternalAllow,
    isReadOnly,
    setServerData,
    setIsConflictModalVisible,
    isTemplateDocument,
    setTemplateData,
    templateData
  } = useDocument();

  const {
    spreadSheet_init,
    spreadsheetInstanceRef,
    onCellSelected,
    onCellsSelected,
    onCellEdited,
    onCellStyle,
    onAddSheet,
    onDeleteSheet,
    onRenameSheet
  } = useSpreadSheet();

  const [isSpreadsheetReady, setIsSpreadsheetReady] = React.useState(false);
  const [spreadsheetData, setSpreadsheetData] = React.useState([]);
  const [docExistsInDb, setIsDocSaved] = React.useState(false);
  const [serverVersionData, setServerVersionData] = useState(null);
  const [dataFetchSuccess, setDataFetchSuccess] = useState(false);
  const hasMounted = React.useRef(false);

  useEffect(() => {
    const fetchServerData = async () => {
      setContentLoading(true);
      try {
        // Check for templateId in query parameters
        const searchParams = new URLSearchParams(location.search);
        const templateId = searchParams.get('templateId');
        if (isTemplateDocument) {
          const response = await templateService.fetchTemplateById(id);
          const templateData = response?.data?.data || null;
          setTemplateData(templateData);
          setDataFetchSuccess(true);
        } else if (templateId) {
          // If templateId is in URL, fetch template data
          const response = await templateService.fetchTemplateById(templateId);
          const rawData = response?.data?.data?.milepadData;
          const templateData = {
            spreadsheetData: rawData ? JSON.parse(rawData) : null
          };
          setServerData(templateData);
          setServerVersionData(templateData);
          setDataFetchSuccess(true);
          // Save template data to current document
          if (templateData?.spreadsheetData) {
            await updateAllSheets(id, templateData.spreadsheetData);
          }
          // Remove templateId from URL
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete('templateId');
          const newSearch = searchParams.toString();
          history.replace({
            pathname: location.pathname,
            search: newSearch ? `?${newSearch}` : ''
          });
        } else {
          const serverData = await loadServerData(id);
          setServerData(serverData);
          setServerVersionData(serverData);
          setDataFetchSuccess(true);
        }
      } catch (error) {
        console.error(`Error loading data for ${isTemplateDocument ? 'template' : 'sheet'} ${id}:`, error);
        message.error(`Failed to load ${isTemplateDocument ? 'template' : 'spreadsheet'} data`);
        setDataFetchSuccess(false);
      } finally {
        setContentLoading(false);
      }
    };

    if (docExistsInDb || isTemplateDocument) {
      fetchServerData();
    }
  }, [id, docExistsInDb, isTemplateDocument, location.search]);

  useEffect(() => {

    const loadSpreadsheetData = (data, updateTime, isExternal) => {
      const finalData = data.filter(item => Object.keys(item).length > 0);
      const fileSize = formatFileSize(new TextEncoder().encode(JSON.stringify(finalData)).length);
      setIsExternalAllow(isExternal);
      setSavingData({ isSaving: '', lastSavedDateTime: '', fileSize });
      setSheets(finalData);
      spreadsheetInstanceRef.current.loadData(finalData, false);
      const allSheetsData = spreadsheetInstanceRef.current.getData();
      const activeSheetData = allSheetsData[0] || null;
      if (activeSheetData && finalData.length === 0) {
        setSpreadsheetData(activeSheetData);
      }
      return finalData;
    };

    const initializeSpreadsheet = async () => {
      // Exit early if spreadsheet is already initialized
      if (isSpreadsheetReady) return;

      // Only proceed if not loading, data fetch was successful, and (serverVersionData exists or it's a template)
      if (contentLoading || !dataFetchSuccess || (!serverVersionData && !isTemplateDocument)) return;

      try {
        if (!isSpreadsheetReady) {
          await spreadSheet_init();
        }

        if (!spreadsheetInstanceRef.current) return;

        if (isTemplateDocument) {
          let sheetsData = [];
          if (templateData?.milepadData && templateData.milepadData !== "string") {
            try {
              sheetsData = JSON.parse(templateData.milepadData);
            } catch (parseError) {
              console.error('Failed to parse template milepadData:', parseError);
              sheetsData = [];
            }
          }
          loadSpreadsheetData(sheetsData, null, false);
          setIsSpreadsheetReady(true);
          return;
        }

        const offlineSheets = JSON.parse(localStorage.getItem('offlineSheets') || '{}');
        const localData = Array.isArray(offlineSheets[id]?.data) ? offlineSheets[id].data : [];
        const localUpdateTime = offlineSheets[id]?.lastUpdateTime || null;

        const serverSheetsData = Array.isArray(serverVersionData?.spreadsheetData)
          ? serverVersionData.spreadsheetData
          : [];
        const serverUpdateTime = serverVersionData?.updatedAt || null;

        const localDate = localUpdateTime ? new Date(localUpdateTime) : null;
        const serverDate = serverUpdateTime ? new Date(serverUpdateTime) : null;

        // Conflict case: both have data and server is newer
        if (localData && serverSheetsData && localDate && serverDate && (serverDate > localDate)) {
          loadSpreadsheetData(localData, localUpdateTime, !!offlineSheets[id]?.isExternal);
          setIsConflictModalVisible(true);
          setIsSpreadsheetReady(true);
          return;
        }

        // Both have data but local is newer 
        if (localData && serverSheetsData && localDate && serverDate && (serverDate < localDate)) {
          loadSpreadsheetData(localData, localUpdateTime, !!offlineSheets[id]?.isExternal);
          updateAllSheets(id, localData);
          removeOfflineData(id);
          setIsSpreadsheetReady(true);
          return;
        }

        // If server data exists load it 
        if (serverSheetsData) {
          loadSpreadsheetData(serverSheetsData, serverUpdateTime, !!serverVersionData?.isExternal);
          setIsSpreadsheetReady(true);
          return;
        }

        // No valid data
        message.error('Unable to load content. Data missing or unavailable.');

      } catch (error) {
        console.error('Spreadsheet initialization failed:', error);
        message.error('Failed to initialize spreadsheet');
      }
    };

    initializeSpreadsheet();
  }, [contentLoading, serverVersionData, dataFetchSuccess, isSpreadsheetReady, spreadsheetInstanceRef, isTemplateDocument, templateData]);

  // Setup all spreadsheet handlers after initialization
  React.useEffect(() => {
    if (isSpreadsheetReady && spreadsheetInstanceRef.current) {
      onCellSelected(id);
      onCellsSelected(id);
      onCellStyle();
      onAddSheet(id, setSavingData, isTemplateDocument);
      onDeleteSheet(id, setSavingData, isTemplateDocument);
      onRenameSheet(id, setSavingData, isTemplateDocument);

      // Setup change listener
      const changeHandler = (data) => {
        setSpreadsheetData(data);
      };
      spreadsheetInstanceRef.current.change(changeHandler);

      // Setup socket listeners
      listenerAddSheet(spreadsheetInstanceRef);
      listenerEditedCellData(spreadsheetInstanceRef);
      onCellEdited(spreadsheetInstanceRef);
      listenerSingularCellSelection(spreadsheetInstanceRef, 'COllab');
      listenerMultipleCellSelection(spreadsheetInstanceRef);
      listenerOnChanged(spreadsheetInstanceRef);
      listenerClients(spreadsheetInstanceRef);
      listenerClientArrOnDisconnect();
      listenerLoadImport(spreadsheetInstanceRef);

      listenAddMember(async () => {
        const response = await workwiseServices.getDocumentById(id);
        if (response && response?.status === 200 && response.data?.data?.rightType !== 0) {
          setDocumentInfo(response?.data?.data);
        }
      });
    }
  }, [isSpreadsheetReady, id]);
  React.useEffect(() => {
    // const sampleData = 
    // {
    //     "spreadsheetID": "xx",
    //     "spreadsheetData": [{
    //         "name": "Sheet 1",
    //         "freeze": "A1",
    //         "styles": [],
    //         "merges": [],
    //         "rows": {
    //             "len": 3000
    //         },
    //         "cols": {
    //             "len": 26
    //         },
    //         "validations": [],
    //         "autofilter": {}
    //     }],
    //     "readOnlySpreadsheet": "r.xx",
    //     "Comments": [],
    //     "__v": 1
    // };
    const createSpreadsheet = async () => {
      await axios.post(
        `${konn}/api/create`,
        {
          id: id,
          data: {},
        }
      );
      setIsDocSaved(true);
    };
    if (!isTemplateDocument) {
      createSpreadsheet();
    } else {
      setIsDocSaved(true); // For templates, assume it's "saved" since no creation needed
    }
  }, [id, isTemplateDocument]);

  // Update spreadsheet data
  useEffect(() => {
    if (!spreadsheetInstanceRef.current) return;

    // Skip the first mount to avoid unnecessary empty update
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    const updateSpreadsheet = async (data) => {
      const isOffline = !window.navigator.onLine;
      const updatedSheets = updateOrAppendSheet(data, sheets);
      setSheets(updatedSheets);

      if (isOffline) {
        // Save to localStorage if offline
        saveToLocalStorage(id, updatedSheets);
        return;
      } else {
        // Save to server if online
        try {
          if (isTemplateDocument) {
            await templateService.updateTemplate({ templateId: id, data: { milepadData: JSON.stringify(updatedSheets), docType: 'milegrid' }, dispatch: setSavingData });
          } else {
            await axios.post(`${konn}/api/update`, {
              spreadsheetID: id,
              spreadsheetData: data,
            });
          }
          if (data.length !== 0) {
            workwiseServices.saveDocumentlastUpdate(id, setSavingData, sheets);
          }
          // Clear localStorage after successful sync
          removeOfflineData(id);
        } catch (error) {
          console.error("Update failed, saving to localStorage:", error);
          saveToLocalStorage(id, updatedSheets);
        }
      }
    };

    const timer = setTimeout(() => {
      updateSpreadsheet(spreadsheetData);
    }, 100);

    return () => clearTimeout(timer);
  }, [spreadsheetData, id]);


  return (
    <div id="spreadsheet-container">
      {contentLoading || !isSpreadsheetReady ? (
        <Loader />
      ) : (
        <>
          <ChatBox />
          <MouseContainer />
        </>
      )}
    </div>
  );

};
